var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "header",
      { staticStyle: { display: "flex", "justify-content": "space-between" } },
      [
        _c(
          "div",
          [
            _c(
              "el-button-group",
              [
                _c("span", { staticStyle: { "font-size": "14px" } }, [
                  _vm._v("分配时间:")
                ]),
                _c("el-date-picker", {
                  staticStyle: { width: "240px", "margin-right": "10px" },
                  attrs: {
                    size: "mini",
                    type: "daterange",
                    editable: false,
                    "value-format": "yyyy-MM-dd",
                    "range-separator": "~",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间",
                    clearable: "",
                    "default-time": ["00:00:00", "23:59:59"]
                  },
                  on: { change: _vm.selectTime },
                  model: {
                    value: _vm.searchSelectTime,
                    callback: function($$v) {
                      _vm.searchSelectTime = $$v
                    },
                    expression: "searchSelectTime"
                  }
                }),
                _c("span", { staticStyle: { "font-size": "14px" } }, [
                  _vm._v("添加状态:")
                ]),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择", size: "mini" },
                    on: { change: _vm.selectStatus },
                    model: {
                      value: _vm.formData.status,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "status", $$v)
                      },
                      expression: "formData.status"
                    }
                  },
                  _vm._l(_vm.options, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]
    ),
    _c(
      "div",
      { staticClass: "table-content" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              height: "calc(100vh - 290px)",
              "default-sort": { prop: "sendTotal", order: "descending" }
            }
          },
          [
            _c("el-table-column", {
              attrs: { type: "index", label: "序号", width: "50" }
            }),
            _c("el-table-column", {
              attrs: { prop: "cusPhone", label: "手机号码", width: "280" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(" " + _vm._s(scope.row.cusPhone) + " "),
                      scope.row.taskStatus != 2
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.handleCopy(
                                    scope.row.cusPhone,
                                    "复制成功",
                                    scope.row.id
                                  )
                                }
                              }
                            },
                            [_vm._v("复制号码")]
                          )
                        : _vm._e(),
                      scope.row.taskStatus == 2
                        ? _c(
                            "el-button",
                            { attrs: { size: "mini", type: "info" } },
                            [_vm._v("空号")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { prop: "cusName", label: "姓名", width: "180" }
            }),
            _c("el-table-column", {
              attrs: { prop: "remark", label: "备注信息" }
            }),
            _c("el-table-column", {
              attrs: { prop: "taskStatus", label: "添加状态" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      scope.row.taskStatus === 1
                        ? _c(
                            "el-tag",
                            { attrs: { type: "success", size: "mini" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.taskStatusENUM[scope.row.taskStatus]
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : scope.row.taskStatus === 0
                        ? _c(
                            "el-tag",
                            { attrs: { type: "danger", size: "mini" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.taskStatusENUM[scope.row.taskStatus]
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _c(
                            "el-tag",
                            { attrs: { type: "warning", size: "mini" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.taskStatusENUM[scope.row.taskStatus]
                                  ) +
                                  " "
                              )
                            ]
                          )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { prop: "approvalStatus", label: "通过情况" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type:
                              scope.row.approvalStatus === 1
                                ? "success"
                                : "danger",
                            size: "mini"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.approvalENUM[scope.row.approvalStatus]
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { prop: "action", label: "操作" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      scope.row.taskStatus != 2
                        ? _c(
                            "a",
                            {
                              staticStyle: {
                                color: "#409eff",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleTabPhone(scope.row.id, 2)
                                }
                              }
                            },
                            [_vm._v("标记为空号")]
                          )
                        : _vm._e(),
                      scope.row.taskStatus == 2
                        ? _c(
                            "a",
                            {
                              staticStyle: {
                                color: "#409eff",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleTabPhone(scope.row.id, 1)
                                }
                              }
                            },
                            [_vm._v("解除标记?")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "footer",
      [
        _c("Pagination", {
          attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
          on: { callBack: _vm.callBack }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }